import clsx from 'clsx';
import { ComponentProps, FC, ReactNode } from 'react';

import styles from './Container.module.scss';

type ContainerProps = Omit<ComponentProps<'div'>, 'children'> & {
  children: ReactNode;
};

export const Container: FC<ContainerProps> = (props) => {
  const { className, children, ...flexProps } = props;

  return (
    <div className={clsx(styles.root, className)} {...flexProps}>
      {children}
    </div>
  );
};
